/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = UNKNOWN
 *
 * 1 = DRIVER
 *
 * 2 = OWNER
 *
 * 3 = OWNER_DRIVER
 */
export enum CustomerVehicleRelationship {
  UNKNOWN = 0,
  DRIVER = 1,
  OWNER = 2,
  OWNER_DRIVER = 3,
}
